import React, { useEffect, useState } from "react";
import { Row, Col, Button, Card, Empty } from "antd";
import styled from "styled-components";
import { FaPlusCircle } from "react-icons/all";
import Select from "react-select";
import { UserAction } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
// import TextField from "@mui/material/TextField";
import CreditCard from "../EmployeCard/creditcard";
import AddPlantCard from "../EmployeCard/addplantCard";
import RadioWrapper from "../RadioWrapper/index";
import { IoIosAddCircleOutline } from "react-icons/io";
import LoaderGif from "../../assets/images/ie_loader.gif";
import "./index.css";
const CheckoutContainer = styled.div`
  min-height: 160px;
  border: solid lightgrey 1px;
  margin-top: 1rem;
  margin-left: 2rem;
`;
function PaymentCard({
  onSubmitPayment,
  error,
  clearError,
  mainHeading,
  isOpenCard,
  orderData,
  onCreditPurchase,
  isCardLoading,
  isCardReqLoading,
  isAchDisable,
  paymentType,
  paymentTypeValue,
  paymentCardFunction,
  paymentCardId
}) {
  console.log("isCardLoading===>", orderData);
  console.log("isCardLoadingtyp===>", paymentTypeValue);



  const [radioValue, setRadioValue] = useState(
    orderData.allowed_for_credit_purchase == true ? paymentTypeValue : paymentTypeValue
  );
  console.log("raioval===>", radioValue);
  const [cardId, setCardId] = useState(paymentCardId);
  const dispatch = useDispatch();
  useEffect(() => {
    // setRadioValue(paymentType)
    dispatch(UserAction.getCardsReq({ per_page: 1000 }, radioValue));
  }, []);
  const onChangeRadio = (value) => {
    paymentType(value)
    setRadioValue(value);
    setCardId("");
    clearError();
    if (value !== "credit-purchase") {
      dispatch(UserAction.getCardsReq({ per_page: 1000 }, value));
    }
  };

  const isLoading = useSelector((store) => store.UserReducer.isLoading);
  const cards = useSelector((store) => store.UserReducer.cards);
  console.log("cards==>", cardId)
  return (
    <Row justify="center" style={{ marginBottom: "2rem" }}>
      <Col span={24} style={{ marginTop: "2.5rem" }}>
        <Row justify="center">
          <Col span={22}>
            <h2 className="text-left checkout-heading">{mainHeading}</h2>
          </Col>
        </Row>
        <CheckoutContainer>
          <Row
            align="middle"
            style={{ marginTop: "0.8rem" }}
            className="text-left"
          >
            <Col
              xl={6}
              lg={6}
              md={10}
              xs={12}
              sm={12}
              style={{
                marginBottom: "0.4rem",
                marginTop: "0.6rem",
                paddingLeft: "20px",
              }}
              className="text-left"
            >
              <h2>Payment Method</h2>
            </Col>
          </Row>
          <Row
            align="middle"
            gutter={[1, 0]}
            style={{ marginBottom: "1.5rem", paddingLeft: "15px" }}
          >
            <Col xl={5} lg={5} md={6} xs={12} sm={12}>
              <RadioWrapper
                value={paymentTypeValue}
                onChange={(e) => onChangeRadio("cards")}
                checked={radioValue === "cards"}
              />
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "300",
                  color: "#9e9e9e",
                }}
              >
                Credit Cards
              </span>
            </Col>
            {isAchDisable && (
              <Col xl={4} lg={4} md={6} sm={24} xs={12}>
                <RadioWrapper
                  value={paymentTypeValue}
                  onChange={(e) => onChangeRadio("bank_accounts")}
                  checked={radioValue === "bank_accounts"}
                />
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "300",
                    color: "#9e9e9e",
                  }}
                >
                  ACH
                </span>
              </Col>
            )}

            {orderData.allowed_for_credit_purchase === true && (
              <Col xl={5} lg={5} md={6} xs={13} sm={13}>
                <RadioWrapper
                  value={paymentTypeValue}
                  onChange={(e) => onChangeRadio("credit-purchase")}
                  checked={radioValue === "credit-purchase"}
                />
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "300",
                    color: "#9e9e9e",
                  }}
                >
                  Credit Purchase
                </span>
              </Col>
            )}
          </Row>
          {radioValue === "credit-purchase" && (
            <Row justify="start">
              <Col span={23}>
                <Row justify="end">
                  <Col span={5}>
                    <Button
                      style={{
                        backgroundColor: "#f57c00 ",
                        color: "#fff",
                        border: "none",
                        width: "100%",
                      }}
                      onClick={() => onCreditPurchase()}
                    >
                      CONTINUE
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}

          {radioValue !== "credit-purchase" && (
            <Row justify="start" style={{ paddingLeft: "15px" }}>
              <Col span={23}>
                <Card
                  style={{ minHeight: "120px", marginBottom: "2rem" }}
                  gutter={[10, 20]}
                >
                  <Row
                    justify="start"
                    style={{ padding: "0.5rem" }}
                    gutter={[12, 10]}
                  >
                    {radioValue === "cards" && (
                      <Col
                        xl={8}
                        lg={12}
                        xs={24}
                        sm={24}
                        md={24}
                        className="payment-card"
                      >
                        <AddPlantCard
                          cardIcon={<IoIosAddCircleOutline size={50} />}
                          cardText="Add New Card"
                          className="ant-card-body"
                          cardStyle={{
                            height: radioValue === "cards" ? "180px" : "200px",
                            border: "1px solid rgba(0, 0, 0, 0.26)",
                            boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 16%)",
                            transition: "box-shadow .25s",
                          }}
                          onChangePlantModal={isOpenCard}
                        />
                      </Col>
                    )}
                    {isCardLoading && (
                      <Row justify="center">
                        <Col>
                          <img src={LoaderGif} height="60" width={60} />
                        </Col>
                      </Row>
                    )}
                    {!cards.length && !isCardLoading && radioValue === "cards" && (
                      <Row justify="end">
                        <Col span={23}>
                          <Empty description="Nothing to show right now" />
                        </Col>
                      </Row>
                    )}
                    {!cards.length &&
                      !isCardLoading &&
                      radioValue === "bank_accounts" && (
                        <Row justify="center">
                          <Col span={23}>
                            <Empty description="Nothing to show right now" />
                          </Col>
                        </Row>
                      )}
                    {!!cards.length &&
                      (cards || []).map((item) => {
                        return (
                          <Col xl={8} lg={8} xs={24} sm={24} md={24}>
                            <CreditCard
                              className="ant-card-body"
                              cardStyle={{
                                height:
                                  radioValue === "cards" ? "180px" : "200px",
                                border: "0px solid #e0e0e0",
                                boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 16%)",
                                transition: "box-shadow .25s",
                              }}
                              checkBoxBtn={true}
                              data={item}
                              onChangeCard={(e) => {
                                clearError();
                                if (cardId == e.id) {
                                  setCardId("");
                                  paymentCardFunction("")
                                  return;
                                }
                                paymentCardFunction(e.id)
                                setCardId(e.id);
                              }}
                              cardId={paymentCardId}
                            />
                          </Col>
                        );
                      })}
                  </Row>
                </Card>
                {!cards.length && radioValue === "cards" && (
                  <Row justify="start" align="middle">
                    <Col className="text-left danger-color">
                      <p>
                        Sorry, please add a payment method before placing an
                        order.
                      </p>
                    </Col>
                  </Row>
                )}
                {!cards.length && radioValue === "bank_accounts" && (
                  <Row justify="start" align="middle">
                    <Col className="text-left danger-color">
                      <p>
                        Sorry, please add a bank account before placing an
                        order.
                      </p>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col span={24} className="text-left ">
                    <small
                      style={{ fontSize: "0.75rem" }}
                      className="text-left danger-color"
                    >
                      {error}
                    </small>
                  </Col>
                </Row>
                <Row justify="end" style={{ marginBottom: "1rem" }}>
                  <Col span={5}>
                    <Button
                      style={{
                        backgroundColor: "#f57c00 ",
                        color: "#fff",
                        border: "none",
                        width: "100%",
                      }}
                      onClick={() => onSubmitPayment(cardId)}
                    >
                      CONTINUE
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </CheckoutContainer>
      </Col>
    </Row>
  );
}
export default PaymentCard;
